import React from 'react';
import createClass from 'create-react-class';
import { withTranslation } from 'react-i18next';

import FiltersActions from '../../../../actions/FiltersActions';

import FiltersConstants from '../../../../constants/FiltersConstants';
import Analytics from 'arbitrip-common/client/analytics';

import FilterCheckboxWithLabel from './components/FilterCheckboxWithLabel.react';

const AvailabilityFilter = createClass({
	displayName: 'AvailabilityFilter',

	handleCheckboxChange: function (event, isInputChecked) {
		const { profile, t } = this.props;

		event.persist();
		FiltersActions.filterByAvailability(isInputChecked);
		setTimeout(function () {
			FiltersActions.filterByAvailability(isInputChecked);
		}, 10);

		const filter_value = t(isInputChecked ? 'ShowOnlyInAvailability' : 'ShowAll');
		Analytics.actions.interactions.filteredResults(
			profile,
			FiltersConstants.FILTER_METHOD.AVAILABILITY,
			filter_value,
		);
	},

	render() {
		const { t } = this.props;
		return (
			<div className="filter disabled">
				<label className="filter-title" htmlFor="availability-filter">
					{t('Availability')}
				</label>
				<div name="availability-filter" className="check-list" aria-label={t('Availability')}>
					<div className="checkbox-container">
						<FilterCheckboxWithLabel
							checked={this.props.filter}
							label={t('HideNoAvailabilityHotels')}
							onChange={(e, c) => this.handleCheckboxChange(e, c)}
						/>
					</div>
				</div>
			</div>
		);
	},
});

export default withTranslation()(AvailabilityFilter);
